import { Injectable } from '@angular/core';
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { CLAccount } from './account';
import { CLAccountService } from './account.service';
import { lookupParam } from '../../nav/utils';
import { NotifierService } from '../../ui';

@Injectable()
export class CLAccountResolver implements Resolve<CLAccount> {

  constructor(
    private router: Router,
    private accountService: CLAccountService,
    private notifier: NotifierService,
  ) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): CLAccount | Observable<CLAccount> | Promise<CLAccount> {
    return new Promise<CLAccount>(async (resolve, reject) => {

      let account_id = lookupParam(route, 'client_account_id');

      this.notifier.startProgress();

      this.accountService
        .account(account_id)
        .subscribe((account) => {
          
          if(account) {
            return resolve(account);
          }
          else {
            this.router.navigate(['shares-ledger', 'client-accounts']);
            return resolve(null);
          }
        });
    });
  }
}